"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles.css");
const LanguagePicker_1 = require("./components/LanguagePicker");
const ThemeToggle_1 = require("./components/ThemeToggle");
const NavigationBar_1 = require("./components/NavigationBar");
const MobileMenu_1 = require("./components/MobileMenu");
const FloatingTableOfContents_1 = require("./components/FloatingTableOfContents");
const ScreenshotsPicker_1 = require("./components/ScreenshotsPicker");
const ScreenshotStrip_1 = require("./components/ScreenshotStrip");
class WebsiteManager {
    navigationBar;
    constructor() {
        this.setupEventListeners();
        const isNewsPage = window.location.pathname.includes('news');
        this.navigationBar = new NavigationBar_1.NavigationBar();
        new LanguagePicker_1.LanguagePicker(isNewsPage);
        new ThemeToggle_1.ThemeToggle();
        // The mobile menu works without this (it is a <details>); the component only
        // adds Escape / outside-click / breakpoint closing. Guarded rather than
        // required so a page that ever ships without the navigation bar still boots.
        const mobileMenu = document.querySelector('#mobileMenu');
        if (mobileMenu) {
            new MobileMenu_1.MobileMenu(mobileMenu);
        }
        // Initialize floating TOC only for news pages
        if (isNewsPage) {
            new FloatingTableOfContents_1.FloatingTableOfContents();
        }
        // Landing page only: the screenshots section is the only place this markup
        // exists, so its absence is normal rather than an error.
        const screenshotsPicker = document.querySelector('.screenshots-picker');
        if (screenshotsPicker) {
            new ScreenshotsPicker_1.ScreenshotsPicker(screenshotsPicker);
        }
        document.querySelectorAll('.screenshots-strip').forEach((strip) => ScreenshotStrip_1.ScreenshotStrip.attach(strip));
    }
    hideLoader() {
        const loader = document.getElementById('loader');
        if (loader) {
            loader.classList.add('opacity-0');
            setTimeout(() => {
                loader.style.display = 'none';
            }, 500); // Match this with the CSS transition duration
        }
    }
    showLoader() {
        const loader = document.getElementById('loader');
        if (loader) {
            loader.style.display = '';
            loader.classList.remove('opacity-0');
        }
    }
    setupEventListeners() {
        window.addEventListener('scroll', () => this.handleStickyNavbarAndFooter());
        // Add click listener for all links. Same-page anchor links (the landing page
        // navigation) and mailto links must NOT show the loader — they never trigger a
        // page load, so the loader would cover the page forever.
        document.addEventListener('click', (e) => {
            // A click another handler already cancelled (the screenshots device picker
            // upgrades its links in place) is not navigating anywhere either.
            if (e.defaultPrevented)
                return;
            const target = e.target;
            const link = target.closest('a');
            if (link &&
                link.href &&
                !link.href.startsWith('javascript:') &&
                !link.href.startsWith('mailto:') &&
                !link.getAttribute('href')?.startsWith('#') &&
                !link.href.includes(window.location.pathname + '#') &&
                !link.href.includes(window.location.pathname) &&
                !link.hasAttribute('download') &&
                link.target !== '_blank') {
                this.showLoader();
            }
        });
    }
    handleStickyNavbarAndFooter() {
        this.navigationBar.updateShadow(window.scrollY > 0);
        const footer = document.getElementById('footer');
        if (footer) {
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            const isContentScrollable = document.body.scrollHeight > window.innerHeight;
            const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;
            if (isMobile || isContentScrollable) {
                footer.classList.toggle('shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]', window.scrollY === 0 || !isAtBottom);
                footer.classList.toggle('dark:shadow-[0_-4px_6px_-1px_rgba(255,255,255,0.1)]', window.scrollY === 0 || !isAtBottom);
            }
            else {
                footer.classList.remove('shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]', 'dark:shadow-[0_-4px_6px_-1px_rgba(255,255,255,0.1)]');
            }
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const manager = new WebsiteManager();
    manager.hideLoader();
    manager.handleStickyNavbarAndFooter();
    // Support form → mailto. The form never uploads anything; it composes a message
    // in the visitor's own email app addressed to support@shapely3d.com. Done here
    // (not a component) because it exists only on the landing page.
    const form = document.getElementById('support-form');
    if (form) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            const value = (name) => form.querySelector(`[name=${name}]`)?.value ?? '';
            const subject = `[Shapely 3D] ${value('subject').trim() || 'Support request'}`;
            const senderName = value('name').trim();
            const body = value('message') + (senderName ? `\n\n— ${senderName}` : '');
            window.location.href = `mailto:support@shapely3d.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        });
    }
});
